import { ColDef, ColGroupDef } from "ag-grid-community";

const formatTons = (value: number | null | undefined): string => {
	if (value == null || value === undefined) return "";
	return value.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

const formatPercent = (value: number | null | undefined): string => {
	if (value == null || value === undefined) return "";
	return `${value.toFixed(2)}%`;
};

export const useEventComparisonData = () => {
	const columnDefs: (ColDef | ColGroupDef)[] = [
		{
			field: "SectionName",
			headerName: "Section",
			flex: 1,
		},
		{
			field: "BilletSize",
			headerName: "Sz",
			flex: 0.5,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "TargetTPH",
			headerName: "Target TPH",
			valueFormatter: (params) => formatTons(params.value),
			flex: 1,
		},
		{
			field: "TargetTPHPercentage",
			headerName: "TPH %",
			valueFormatter: (params) => formatPercent(params.value),
			flex: 0.8,
			minWidth: 80,
		},
		{
			field: "EffectiveTargetTPH",
			headerName: "Effective TPH",
			valueFormatter: (params) => formatTons(params.value),
			flex: 1,
		},
		{
			headerName: "Scheduled",
			children: [
				{
					field: "ScheduledChargedTons",
					headerName: "Charged",
					valueFormatter: (params) => formatTons(params.value),
					flex: 0.9,
					minWidth: 90,
				},
				{
					field: "ScheduledRolledTons",
					headerName: "Rolled",
					valueFormatter: (params) => formatTons(params.value),
					flex: 0.9,
					minWidth: 90,
				},
				{
					field: "ScheduledFinishedTons",
					headerName: "Finished",
					valueFormatter: (params) => formatTons(params.value),
					flex: 0.9,
					minWidth: 90,
				},
				{
					field: "BudgetTPH",
					headerName: "Budget TPH",
					valueFormatter: (params) => formatTons(params.value),
					flex: 0.8,
					minWidth: 80,
				},
				{
					field: "ScheduledRollingHours",
					headerName: "Hours",
					valueFormatter: (params) => formatTons(params.value),
					flex: 0.8,
					minWidth: 80,
				},
				{
					field: "ScheduledMillYield",
					headerName: "Mill Yield",
					valueFormatter: (params) => formatPercent(params.value),
					flex: 0.9,
					minWidth: 90,
				},
				{
					field: "ScheduledFinishedYield",
					headerName: "Finished Yield",
					valueFormatter: (params) => formatPercent(params.value),
					flex: 1,
					minWidth: 100,
				},
			],
		},
	];

	return { columnDefs };
};
